module.exports = __webpack_public_path__ + "static/img/アセット 16@2x.444c537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 16@2x.png
// module id = vXsP
// module chunks = 1